(function () {
  function getVariants(container) {
    var script = container.querySelector('script[type="application/json"]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function getFieldsets(container) {
    return Array.prototype.slice.call(container.querySelectorAll('fieldset'));
  }

  function getSelects(container) {
    return Array.prototype.slice.call(container.querySelectorAll('select.select__select'));
  }

  function currentSelections(container) {
    var fieldsets = getFieldsets(container);
    if (fieldsets.length) {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    var selects = getSelects(container);
    return selects.map(function (s) {
      return s.value;
    });
  }

  function isAvailable(variants, candidate) {
    return variants.some(function (v) {
      if (!v.available) return false;
      for (var i = 0; i < candidate.length; i++) {
        if (candidate[i] !== null && v.options[i] !== candidate[i]) return false;
      }
      return true;
    });
  }

  function refresh(container) {
    var variants = getVariants(container);
    if (!variants.length) return;
    var selections = currentSelections(container);

    var fieldsets = getFieldsets(container);
    if (fieldsets.length) {
      fieldsets.forEach(function (fieldset, idx) {
        var inputs = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
        var visibleChecked = null;
        inputs.forEach(function (input) {
          var candidate = selections.slice();
          candidate[idx] = input.value;
          var ok = isAvailable(variants, candidate);
          var label = fieldset.querySelector('label[for="' + input.id + '"]');
          input.style.display = ok ? '' : 'none';
          if (label) label.style.display = ok ? '' : 'none';
          if (ok && input.checked) visibleChecked = input;
        });
        if (!visibleChecked) {
          var firstVisible = inputs.find(function (input) {
            return input.style.display !== 'none';
          });
          if (firstVisible && !firstVisible.checked) {
            firstVisible.checked = true;
            firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    } else {
      var selects = getSelects(container);
      selects.forEach(function (select, idx) {
        var options = Array.prototype.slice.call(select.options);
        var hasCheckedVisible = false;
        options.forEach(function (option) {
          var candidate = selections.slice();
          candidate[idx] = option.value;
          var ok = isAvailable(variants, candidate);
          option.hidden = !ok;
          option.disabled = !ok;
          if (ok && option.selected) hasCheckedVisible = true;
        });
        if (!hasCheckedVisible) {
          var firstVisible = options.find(function (o) {
            return !o.hidden;
          });
          if (firstVisible) {
            select.value = firstVisible.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('variant-radios, variant-selects').forEach(function (container) {
      refresh(container);
      container.addEventListener('change', function () {
        setTimeout(function () {
          refresh(container);
        }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
